<div class="card">
	<p-chart #chartLine type="line" [data]="basicData" [options]="basicOptions"></p-chart>

	<lib-progress-spinner *ngIf="graphLoading"></lib-progress-spinner>
</div>